// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__pryUO","progress":"Loader_progress__1VXgd"};